import React, {useEffect, useState} from "react";
import {IonModal} from "@ionic/react";
import {ChevronRight} from "../components/icons";
import ReportDetail from "./ReportDetail";
import {ApiService} from "../api/ApiService";
import {Trainee} from "../api/model/Trainee";
import {TrainingReport} from "../api/model/TrainingReports";

export interface ReportReference {
    date: string,
    trainerCode: string
}

function formatListDate(raw: string): string {
    const d = new Date(raw.includes('T') || raw.includes('-') ? raw : raw.replace(' ', 'T'));
    if (isNaN(d.getTime())) return raw;
    return d.toLocaleDateString(undefined, {month: 'short', day: 'numeric', year: 'numeric'});
}

const ReportHistory = (props: any) => {

    const [showHistory, setShowHistory] = useState(false)
    const [reports, setReports] = useState<ReportReference[]>([]);
    const [loading, setLoading] = useState(true);
    const [selectedDate, setSelectedDate] = useState<string | null>(null);
    const [showReportModal, setShowReportModal] = useState(false);

    useEffect(() => {
        setLoading(true);
        ApiService.getTrainingReports2('reportHistory', {traineeCode: props.trainee.traineeCode}, true).then(it => {
            parseReports(it.reports);
        }).finally(() => setLoading(false));
    }, [props.trainee.traineeCode]);

    const parseReports = (reportsArray: TrainingReport[]) => {
        let tempArray: ReportReference[] = []
        reportsArray.forEach(element => {
            tempArray.push({date: element.date, trainerCode: element.trainerCode});
        });
        setReports(tempArray);
    }

    const openReport = (date: string) => {
        setSelectedDate(date);
        setShowReportModal(true);
    }

    const closeReport = () => {
        setShowReportModal(false);
        setSelectedDate(null);
    }

    return (
        <div className="training-report-history">
            <button
                type="button"
                className={`training-report-history__toggle${showHistory ? ' is-open' : ''}`}
                onClick={() => setShowHistory(open => !open)}
                aria-expanded={showHistory}
            >
                <span>{showHistory ? 'Hide history' : 'See history'}</span>
                <span className={`training-report-history__chevron${showHistory ? ' is-open' : ''}`} aria-hidden="true">
                    <ChevronRight />
                </span>
            </button>

            {showHistory ? (
                <div className="training-report-history__panel">
                    <div className="training-report-history__panel-title">Report History</div>

                    {loading ? (
                        <p className="training-report-history__empty">Loading reports…</p>
                    ) : reports.length === 0 ? (
                        <p className="training-report-history__empty">No past reports for this trainee.</p>
                    ) : (
                        <div className="training-report-history__list">
                            {reports.map(it => (
                                <button
                                    type="button"
                                    key={it.date}
                                    className="training-report-history__row"
                                    onClick={() => openReport(it.date)}
                                >
                                    <span className="training-report-history__row-text">
                                        <span className="training-report-history__row-date">{formatListDate(it.date)}</span>
                                        <span className="training-report-history__row-meta">Trainer {it.trainerCode}</span>
                                    </span>
                                    <span className="training-report-history__row-action">View report</span>
                                    <ChevronRight />
                                </button>
                            ))}
                        </div>
                    )}

                    {!loading && reports.length > 0 ? (
                        <p className="training-report-history__count">Showing {reports.length} result{reports.length === 1 ? '' : 's'}.</p>
                    ) : null}
                </div>
            ) : null}

            <IonModal isOpen={showReportModal} onDidDismiss={closeReport}>
                {selectedDate ? (
                    <ReportDetail traineeCode={(props.trainee as Trainee).traineeCode} date={selectedDate} onClose={closeReport} />
                ) : null}
            </IonModal>
        </div>
    )
}

export default ReportHistory
